import { Component, HostListener, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { routerTransition } from '@app/shared/utils/animations';
import { AccountService } from '@app/core/services/Common/account.service';
import { Permission } from '@app/shared/models/Authentication/permission.model';
import { AccountEndpoint } from '@app/core/endpoints/account-endpoint.service';
import { AppSettings } from '@app/services/app-settings.service';
import { AuthService } from '@app/core/services';
import { NavigationComponent } from '../navigation';

@Component({
  providers:[AccountService,AccountEndpoint],
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styles: [],
  animations: [routerTransition]
})
export class MainLayoutComponent implements OnInit, AfterViewInit {

  
  @ViewChild(NavigationComponent, { static: false }) navigationComponent: NavigationComponent;


  appHasScroll: boolean;
  constructor(private accountService: AccountService  ,private authService: AuthService,public appSettings: AppSettings) {}
  menus: any[];
  ngOnInit() {
    document.documentElement.setAttribute('data-bs-theme', '');
    
    // here we can do 
  }

  ngAfterViewInit() {
    this.authService.userTenantMap$.subscribe((tenants) => {
      this.navigationComponent?.setupMenu();
   });
  }
  onAppSidebarEndMobileToggled(val: boolean): void {
  	this.appSettings.appSidebarEndMobileToggled = !this.appSettings.appSidebarEndMobileToggled;
	}
  onAppSidebarMinifiedToggled(val: boolean): void {
  	this.appSettings.appSidebarMinified = !this.appSettings.appSidebarMinified;
  	if (localStorage) {
			localStorage['appSidebarMinified'] = this.appSettings.appSidebarMinified;
		}
	}
  onAppSidebarEndToggled(val: boolean): void {
  	this.appSettings.appSidebarEndToggled = !this.appSettings.appSidebarEndToggled;
	}

  onAppSidebarMobileToggled(val: boolean): void {
  	this.appSettings.appSidebarMobileToggled = !this.appSettings.appSidebarMobileToggled;
	}

  getState(outlet) {
    if (!outlet.activatedRoute) { return; }
    const ss = outlet.activatedRoute.snapshot;

    // return unique string that is used as state identifier in router animation
    return (
      outlet.activatedRouteData.state ||
      (ss.url.length
        ? ss.url[0].path
        : ss.parent.url.length
          ? ss.parent.url[0].path
          : null)
    );
  }
  canAccessThemes(){
    //return this.accountService.userHasPermission(Permission.themeAccess)
    return false;
  }
  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    const doc = document.documentElement;
    const top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
    if (top > 0 ) { //&& this.appSettings.appHeaderFixed
      this.appHasScroll = true;
    } else {
      this.appHasScroll = false;
    }
  }
}
 

